// extracted by mini-css-extract-plugin
module.exports = {"pointsFilter":"PointsFilter_pointsFilter__P5FpO","filterBtn":"PointsFilter_filterBtn__OUVBk","active":"PointsFilter_active__lwyn9"};